import axios from 'axios';
import { useQuery } from 'react-query';
import Config from '../global/env';

const fetchData = async (): Promise<string[]> => {
    const { data } = await axios.get(Config.storesURL);
    return data;
}

const useStores = () => {
    return useQuery<string[], Error>('stores', fetchData)
}

export default useStores;